import { AuthWrapper } from '@features/auth/AuthWrapper/RegistrationWrapper';
import { usePageTitle } from '@hooks/usePageTitle';
import { useTranslation } from 'react-i18next';

export const Login = () => {
	const { t } = useTranslation();

	usePageTitle(`${t('loginTitle')}`);

	return <AuthWrapper />;
};
